module.exports = __webpack_public_path__ + "img/brand-telegram.svg";